import { createSlice } from '@reduxjs/toolkit';

interface quickChatSlice {
  quickChat: {
    id: string;
    name?: string;
    content?: string;
  };
}

const initialState: quickChatSlice = {
  quickChat: {
    id: '',
    name: '',
    content: '',
  },
};

export const quickChatSlice = createSlice({
  name: 'quickChat',
  initialState,
  reducers: {
    selectQuickChat: (state, { payload }) => {
      state.quickChat = { ...payload, header: {} };
    },
    resetQuickChat: (state) => {
      state.quickChat = initialState.quickChat;
    },
    setQuickChat: (state, action) => {
      state.quickChat = action.payload;
    },
    removeQuickChat: (state) => {
      state.quickChat = { id: '' };
    },
  },
});

export const { setQuickChat, removeQuickChat, resetQuickChat, selectQuickChat } =
  quickChatSlice.actions;

export default quickChatSlice.reducer;
